import Rest from '../Rest'

export default class AreaCodeService extends Rest {
  /**
   * @type {String}
   */
  static resource = '/api/v1/area_codes'

  static build(vs: any = null) {
    return new this(this.resource, null, vs)
  }
}
